var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "setting",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 25,
    height: 25,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings_1_",
    "data-name": "settings (1)",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M300.5,300.848a.416.416,0,0,0,0,.591l3.876,3.876.332-.332.259-.259-3.872-3.876A.42.42,0,0,0,300.5,300.848Z",
    transform: "translate(-291.066 -291.392)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M17.1,8.385V7.6a.6.6,0,0,0-.5-.592l-1.56-.26a6.525,6.525,0,0,0-.7-1.687l.917-1.29A.6.6,0,0,0,15.194,3l-.551-.551L14.093,1.9a.6.6,0,0,0-.77-.062l-1.29.917a6.525,6.525,0,0,0-1.687-.7L10.083.5A.6.6,0,0,0,9.491,0H7.924a.622.622,0,0,0-.578.51l-.26,1.56a6.525,6.525,0,0,0-1.687.7L4.11,1.851a.6.6,0,0,0-.77.065l-.547.558-.551.551a.6.6,0,0,0-.062.77L3.1,5.084a6.081,6.081,0,0,0-.7,1.728L.849,7.075a.6.6,0,0,0-.5.592V9.234a.6.6,0,0,0,.5.592l1.574.267a6.563,6.563,0,0,0,.7,1.676L2.2,13.038a.6.6,0,0,0,.065.77l.551.551.551.551a.6.6,0,0,0,.77.062l1.3-.924a6.492,6.492,0,0,0,1.687.684l.263,1.543a.6.6,0,0,0,.592.5H9.546a.6.6,0,0,0,.592-.5L10.4,14.7c.137-.034.27-.075.4-.12.034-.01.072-.024.106-.038.109-.038.216-.079.322-.123l.072-.031c.127-.055.25-.113.373-.174,0,0,.007,0,.01-.007.123-.062.246-.13.363-.2.075-.044.151-.092.222-.14l-2.012-2.012a1.758,1.758,0,0,0-1.368-.5A3.095,3.095,0,0,1,5.68,7.509a.1.1,0,0,1,.164-.044L7.1,8.721a.965.965,0,0,0,1.362,0l.571-.571a.965.965,0,0,0,0-1.362L7.716,5.464A.1.1,0,0,1,7.753,5.3,3.093,3.093,0,0,1,11.78,8.587a1.78,1.78,0,0,0,.5,1.457l1.906,1.906c.062-.1.12-.192.178-.287.065-.113.127-.226.185-.342l.051-.1c.038-.079.072-.157.109-.239.027-.062.055-.127.079-.188.017-.041.031-.086.048-.13.034-.089.065-.178.1-.27h0c.038-.123.075-.243.109-.366l1.56-.263a.6.6,0,0,0,.5-.592Z",
    transform: "translate(-0.35 0)",
    fill: "#545454"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.10360e11b8f0e100a80079eb51401674.svg";
export { ForwardRef as ReactComponent };